var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZipSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#fff}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_PDF_36pt",
    "data-name": "Icon/PDF/36pt",
    transform: "translate(-26 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25649",
    "data-name": "Group 25649",
    transform: "translate(-325.5 -412.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13624",
    "data-name": "Path 13624",
    d: "M159.172 137a2 2 0 0 1 1.414.586l7.828 7.828a2 2 0 0 1 .586 1.414V164a3.009 3.009 0 0 1-3 3h-18.015a3 3 0 0 1-2.985-3v-24a3.009 3.009 0 0 1 3-3zm.828 1.75v5.75a1.5 1.5 0 0 0 1.5 1.5h5.75z",
    transform: "translate(212.5 281.5)",
    style: {
      fill: "#212121",
      fillRule: "evenodd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13625",
    "data-name": "Path 13625",
    className: "cls-3",
    d: "M149.807 158v-1.068l3.456-5.268h-3.132v-1.488h5.3v1.068l-3.456 5.268h3.492V158zm6.484 0v-7.824h1.764V158zm3.11 0v-7.824h2.688a5.31 5.31 0 0 1 1.212.132 2.6 2.6 0 0 1 .984.42 1.972 1.972 0 0 1 .66.78 2.534 2.534 0 0 1 .252 1.188 2.627 2.627 0 0 1-.252 1.188 2.248 2.248 0 0 1-.66.828 2.836 2.836 0 0 1-.972.48 4.306 4.306 0 0 1-1.176.156h-.972V158zm1.764-4.056h.864q1.44 0 1.44-1.248a.955.955 0 0 0-.384-.864 2.013 2.013 0 0 0-1.1-.252h-.816z",
    transform: "translate(212.5 281.5)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3762",
    "data-name": "Rectangle 3762",
    className: "cls-3",
    width: 4,
    height: 6,
    rx: 2,
    transform: "translate(363.5 419.5)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3763",
    "data-name": "Rectangle 3763",
    width: 2,
    height: 2,
    rx: 1,
    transform: "translate(364.5 422.5)",
    style: {
      fill: "#424242"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3764",
    "data-name": "Rectangle 3764",
    className: "cls-3",
    width: 2,
    height: 1,
    rx: 0.5,
    transform: "translate(364.5 426.5)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3765",
    "data-name": "Rectangle 3765",
    className: "cls-3",
    width: 2,
    height: 1,
    rx: 0.5,
    transform: "translate(364.5 428.5)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3766",
    "data-name": "Rectangle 3766",
    className: "cls-3",
    width: 2,
    height: 1,
    rx: 0.5,
    transform: "translate(364.5 441.5)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3767",
    "data-name": "Rectangle 3767",
    className: "cls-3",
    width: 2,
    height: 1,
    rx: 0.5,
    transform: "translate(364.5 443.5)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3768",
    "data-name": "Rectangle 3768",
    className: "cls-3",
    width: 2,
    height: 1,
    rx: 0.5,
    transform: "translate(364.5 445.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipSmall);
export default __webpack_public_path__ + "static/media/zip-small.b0062adf9016cc601c29fdb87d4da33f.svg";
export { ForwardRef as ReactComponent };